import { setAttributes, removeAttributes } from 'utils/dom';
import { uniqueId } from 'utils/helper';
import Shower from 'modules/shower';

export default class MobileAccordion {
  constructor(props) {
    this.container = props.container;
    this.handler = props.handler;
    this.target = props.target;
    this.breakpoint = props.breakpoint;
    this.showFirst = props.showFirst;
    this.initOpened = props.initOpened || false;
    this.accordions = props.accordions || null;
    this.accordionShower = null;
    this.mobileAccordionIsInitialized = false;
  }

  setAttributes = () => {
    const randomID = uniqueId();

    if (this.handler) {
      setAttributes(this.handler, {
        id: `acc-btn-${randomID}`,
        'aria-controls': `acc-tab-${randomID}`,
      });

      setAttributes(this.target, {
        id: `acc-tab-${randomID}`,
        'aria-labelledby': `acc-btn-${randomID}`,
        role: 'region',
      });
    }
  };

  removeAttributes = () => {
    removeAttributes(this.handler, ['id', 'aria-controls', 'aria-expanded']);
    removeAttributes(this.target, [
      'id',
      'aria-labelledby',
      'aria-hidden',
      'role',
    ]);
  };

  initAccordionShower = () => {
    let initOpened;

    if (this.showFirst) {
      if (this.container === this.accordions[0]) initOpened = true;
    } else {
      initOpened = this.initOpened;
    }

    this.accordionShower = new Shower({
      target: this.target,
      handler: this.handler,
      easing: 'easeInOutQuart',
      duration: 400,
      initOpened: initOpened,
      openClassName: 'is-active',
    });

    if (
      window.innerWidth < this.breakpoint &&
      !this.mobileAccordionIsInitialized
    ) {
      this.accordionShower.init();
      this.mobileAccordionIsInitialized = true;
    }
  };

  onResize = () => {
    if (window.innerWidth >= this.breakpoint) {
      if (this.mobileAccordionIsInitialized) {
        this.accordionShower && this.accordionShower.destroy();
        this.accordionShower = null;
        this.mobileAccordionIsInitialized = false;
        this.removeAttributes();
      }
    } else {
      if (!this.mobileAccordionIsInitialized) {
        this.setAttributes();
        this.initAccordionShower();
      }
    }
  };

  bindEvents = () => {
    window.addEventListener('resize', () => this.onResize());
  };

  init = () => {
    if (window.innerWidth < this.breakpoint) {
      this.setAttributes();
    }
    this.bindEvents();
    this.handler && this.initAccordionShower();
  };
}
